import compose from 'lodash/fp/compose';
import React from 'react';
import { DragSource, type DragSourceConnector, type DragSourceMonitor, DropTarget } from 'react-dnd';
import type { WithDraggableProps } from '../../common/components/with-draggable/with-draggable.js';
import { ITEM_TYPE, SOURCE_TYPE } from '../constants.js';
import { dropTargetCollect, itemDropTargetSpec } from './dnd.js';

export const dragSpec = {
  beginDrag(props: WithDraggableProps) {
    return { path: props.path, index: props.index };
  },
  endDrag(props: WithDraggableProps) {
    return props.onBlur(props.formName, props.path);
  }
};

export const dragCollect = (connect: DragSourceConnector, monitor: DragSourceMonitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isDragging: monitor.isDragging()
});

export const DragPreviewContext = React.createContext(false);

// Wrap the component with a context provider to inject isDragging
export const withDragPreviewContext =
  <P extends { isDragging: boolean }>(Component: React.ComponentType<P>) =>
  (props: P) => (
    <DragPreviewContext.Provider value={props.isDragging}>
      <Component {...props} />
    </DragPreviewContext.Provider>
  );

export default compose(
  DragSource(SOURCE_TYPE, dragSpec, dragCollect),
  withDragPreviewContext,
  DropTarget([SOURCE_TYPE, ITEM_TYPE], itemDropTargetSpec, dropTargetCollect)
);
